var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('p',{staticClass:"text-dark"},[_vm._v(" Time Remaining: "),_c('span',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.formatTime))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }